import React, { useEffect, useState, useContext } from "react";
import { NewProjectContext } from "./NewProjectContext";
import { showToast } from "services/utils/Status";
import * as Mui from "@mui/material";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { themes, optionalAvathar } from "services/constants";
import { useHistory } from "react-router-dom";
import { AskProjectWorkFlow } from "./AskProjectWorkFlow";
import { useAutocomplete } from "@mui/base/useAutocomplete";
import PropTypes from "prop-types";
import { projectPlaceholder } from "services/constants/PlaceHolder";
import {
  setEditProject,
  setProjectStatus,
} from "services/Redux/leaveManagement";
import { useDispatch } from "react-redux";
import { setGlobalSearchValue } from "services/Redux/userToken";
import { CreateClient } from "./CreateClient";
import { CustomButton } from "components/CustomComponents/CustomButton";
import {
  Person,
  Check,
  Close,
  AccountTree,
  CorporateFare,
} from "@mui/icons-material";
import sessionHandling from "services/utils/notificationUtils";
import { BackArrow } from "components/CustomComponents/BackArrow";
import { formKeyText, tooltipStyleProps } from "services/constants/Styles";
import { Info } from "@mui/icons-material";

const NewProjects = () => {
  const requestCompanyId = useSelector((state) => state.tokenReducer.topbarCompanyId);
  const {
    allClients,
    clientId,
    setClientId,
    clientName,
    setClientName,
    allClientsId,
  } = useContext(NewProjectContext);
  const history = useHistory();
  const dispatch = useDispatch();
  const { domain, token, userDetails } = useSelector(
    (state) => state.tokenReducer
  );
  const [openCreateClient, setOpenCreateClient] = useState(false);
  const [autocompleteVisible, setAutocompleteVisible] = useState(false);
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [allCompanies, setAllCompanies] = useState([]);
  const [companyName, setCompanyName] = useState("");
  const [estimateAmount, setEstimateAmount] = useState(0);
  const [clientUniqueId, setClientUniqueId] = useState(null);
  const [companyId, setCompanyId] = useState(null);
  const [workflowId, setWorkflowId] = useState(0);
  const [members, setMembers] = useState([]);
  const [projectLead, setProjectLead] = useState(userDetails.username);
  const [projectLeadId, setProjectLeadId] = useState(userDetails.id);
  const [projectName, setProjectName] = useState("");
  const [page, setPage] = useState("Create Project");
  const [createProject, setCreateProject] = useState(false);
  // const classes = useStyles();
  const {
    getRootProps,
    getInputProps,
    getTagProps,
    getListboxProps,
    getOptionProps,
    groupedOptions,
    setAnchorEl,
  } = useAutocomplete({
    id: "customized-hook-demo",
    multiple: true,
    options: members,
    getOptionLabel: (option) => option.username,
    value: selectedMembers,
    onChange: (event, newValue) => {
      setSelectedMembers(newValue);
    },
  });
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    reset,
    trigger,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    setValue("projectLead", userDetails.username);
  }, [setValue, userDetails.username]);

  useEffect(() => {
    const fetchCompanyData = async () => {
      try {
        const response = await fetch(`${domain}company/`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `token ${token}`,
          },
        });
        const res = await response.json();
        if (response.ok) {
          const companies = Array.isArray(res) ? res : (res?.results ?? []);
          const companyDetails = companies.map((obj) => ({
            ...obj,
            label: obj.companyname,
          }));
          setAllCompanies(companyDetails);
        } else if (response.status === 409) {
          sessionHandling();
        } else {
          throw new Error('REQUEST_FAILED');
        }
      } catch (error) {
        console.error('[Newprojectmain] operation failed:', error);
        showToast("error", "Couldn't load project details. Please refresh the page.");
      }
    };
    fetchCompanyData();
  }, [domain, token]);

  useEffect(() => {
    const getMembers = async () => {
      try {
        const response = await fetch(`${domain}selected_members/?company_id=${requestCompanyId}`, {
          method: "GET",
          headers: {
            "content-type": "application/json",
            Authorization: `token ${token}`,
          },
        });
        const res = await response.json();
        if (response.ok) {
          const memberList = res.map((obj) => ({
            ...obj,
            label: obj.username,
            username: obj.username,
          }));
          setMembers(memberList);
        } else if (response.status === 409) {
          sessionHandling();
        } else {
          throw new Error('REQUEST_FAILED');
        }
      } catch (error) {
        console.error('[Newprojectmain] operation failed:', error);
        showToast("error", "Couldn't load project details. Please refresh the page.");
      }
    };
    getMembers();
  }, [domain, token, requestCompanyId]);

  const goToNextPage = (data) => {
    setPage("AskProjectWorkFlow");
    setProjectName(data.projectname);
  };

  const handleKeyPress = (e) => {
    const charCode = e.charCode;
    if (charCode < 48 || charCode > 57) {
      e.preventDefault();
    }
  };

  const handleCloseDialogBox = () => {
    setOpenCreateClient(false);
  };

  const getComponent = (page) => {
    switch (page) {
      case "AskProjectWorkFlow":
        return (
          <AskProjectWorkFlow
            setPage={setPage}
            setWorkflowId={setWorkflowId}
            workflowId={workflowId}
            setCreateProject={setCreateProject}
          />
        );
      default:
        return <Mui.Grid></Mui.Grid>;
    }
  };

  const handleKeyDown = (e) => {
    const allowedKeys = /^[A-Z 0-9 a-z\s]$/;
    if (!allowedKeys.test(e.key)) {
      e.preventDefault();
    }
  };

  useEffect(() => {
    const createNewProject = async () => {
      try {
        const response = await fetch(`${domain}create_project/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `token ${token}`,
          },
          body: JSON.stringify({
            project_name: projectName,
            project_lead: projectLeadId,
            client_id: clientUniqueId,
            estimation_amount: estimateAmount,
            selected_members: selectedMembers,
            autocomplete_visible: true,
            company_id: companyId,
            workflow_id: workflowId,
          }),
        });
        const res = await response.json();
        if (response.ok) {
          reset();
          let status = [];
          res?.data?.workflow?.statuses.forEach((element) => {
            status.push(element.name);
          });
          dispatch(setProjectStatus(status));
          localStorage.setItem("currentEditProject", JSON.stringify(res.data));
          dispatch(setEditProject(res.data));
          dispatch(setGlobalSearchValue(""));
          history.push("/admin/project/task");
          showToast("success", res.message);
        } else if (response.status === 409) {
          sessionHandling();
        } else {
          throw new Error('REQUEST_FAILED');
        }
      } catch (error) {
        console.error('[Newprojectmain] operation failed:', error);
        showToast("error", "Couldn't create the project. Please try again.");
      } finally {
        setCreateProject(false);
      }
    };
    if (createProject) {
      createNewProject();
    }
  }, [
    clientUniqueId,
    companyId,
    createProject,
    dispatch,
    domain,
    estimateAmount,
    history,
    projectLead,
    projectLeadId,
    projectName,
    reset,
    selectedMembers,
    token,
    workflowId,
  ]);

  return (
    <React.Fragment>
      {page === "Create Project" ? (
        <>
          <Mui.Grid container sx={{ paddingTop: 2 }}>
            <Mui.Grid xs={12}>
              <Mui.Stack direction="row">
                <BackArrow
                  actionFunction={() => {
                    dispatch(setGlobalSearchValue(""));
                    history.push("/admin/project/project-management");
                  }}
                />
                &nbsp;
                <Mui.Typography
                  color={themes.headLine}
                  sx={{ fontWeight: "bold", fontSize: 25, paddingTop: 1 }}
                >
                  Create new project
                </Mui.Typography>
              </Mui.Stack>
            </Mui.Grid>
          </Mui.Grid>

          <form onSubmit={handleSubmit(goToNextPage)}>
            <Mui.Grid
              containter
              sx={{ paddingLeft: 20, paddingRight: 20, paddingTop: 4 }}
            >
              <Mui.Grid container>
                <Mui.Grid
                  xs={12}
                  sx={{
                    padding: 0.5,
                    backgroundColor: themes.primary,
                    borderRadius: "10px 10px 0 0",
                    border: `2px solid ${themes.sidebarDivider}`,
                    borderBottom: "none",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Mui.Typography
                    sx={{ fontSize: 24, fontWeight: 800, font: "bold" }}
                  >
                    Create new project
                  </Mui.Typography>
                </Mui.Grid>
              </Mui.Grid>
              <Mui.Grid
                container
                sx={{
                  borderRadius: "0 0 10px 10px",
                  border: `2px solid ${themes.sidebarDivider}`,
                  padding: 2,
                }}
              >
                <Mui.Grid container sx={{ padding: 1 }}>
                  <Mui.Grid xs={4}>
                    <Mui.Typography sx={formKeyText}>
                      {" "}
                      Project Name&nbsp;
                      <Mui.Tooltip
                        arrow
                        slotProps={tooltipStyleProps}
                        title="Enter a unique and descriptive name for the project.This will be used as the project identifier across the platform."
                      >
                        <Info />
                      </Mui.Tooltip>
                    </Mui.Typography>
                  </Mui.Grid>
                  <Mui.Grid xs={8}>
                    <Mui.TextField
                      InputLabelProps={{
                        shrink: true,
                        sx: { fontSize: 17 },
                      }}
                      fullWidth
                      {...register("projectname", {
                        required: "Project name is required",
                        maxLength: {
                          value: 30,
                          message: "Maximum length is 30 characters",
                        },
                        minLength: {
                          value: 3,
                          message: "Minium length is 3 characters",
                        },
                        validate: {
                          noDigitsOrSpecial: (fieldValue) => {
                            if (!/[A-Za-z]/.test(fieldValue)) {
                              return "Project name must contain at least one alphabet character.";
                            }
                            if (/^\d+$/.test(fieldValue)) {
                              return "Project name should not contain only digits.";
                            }
                            if (!/^[A-Za-z0-9\s&-]+$/.test(fieldValue)) {
                              return "Project name should only contain alphabets, spaces, -,numbers and & symbol.";
                            }
                            return true;
                          },
                          projectAvailable: async (fieldValue) => {
                            if (fieldValue !== "") {
                              try {
                                const response = await fetch(
                                  `${domain}check_project_name/?project_name=${fieldValue}`,
                                  {
                                    method: "GET",
                                    headers: {
                                      "content-type": "application/json",
                                      Authorization: `token ${token}`,
                                    },
                                  }
                                );
                                const res = await response.json();
                                if (response.ok) {
                                  if (res?.exists) {
                                    return "Project name already taken.Choose a unique name.";
                                  } else {
                                    return true;
                                  }
                                } else if (response.status === 409) {
                                  sessionHandling();
                                } else {
                                  throw new Error('REQUEST_FAILED');
                                }
                              } catch (error) {
                                console.error('[Newprojectmain] operation failed:', error);
                                showToast("error", "Couldn't create the project. Please try again.");
                              }
                            }
                          },
                        },
                      })}
                      name="projectname"
                      error={errors.name ? true : false}
                      sx={{ background: themes.whiteColor }}
                      placeholder={projectPlaceholder.projectName}
                      onBlur={() => {
                        setValue(
                          "projectname",
                          getValues("projectname").replace(/S[^a-zA-Z]+/g, "")
                        );
                      }}
                      size="small"
                      onKeyPress={handleKeyDown}
                      InputProps={
                        ({
                          startAdornment: (
                            <>
                              <AccountTree
                                style={{
                                  margin: "0 8px",
                                  color: themes.allIconColor,
                                }}
                              />
                            </>
                          ),
                        },
                        {
                          inputProps: { maxLength: 30 },
                        })
                      }
                    />
                    {errors.projectname && (
                      <Mui.Typography
                        sx={{
                          color: themes.redColor,
                          fontSize: 12,
                        }}
                      >
                        {errors.projectname.message}
                      </Mui.Typography>
                    )}
                  </Mui.Grid>
                </Mui.Grid>

                <Mui.Grid container sx={{ padding: 1 }}>
                  <Mui.Grid xs={4}>
                    <Mui.Typography sx={formKeyText}>
                      {" "}
                      Project Lead&nbsp;
                      <Mui.Tooltip
                        arrow
                        slotProps={tooltipStyleProps}
                        title="Select the team member responsible for overseeing the project.The project lead will manage progress, tasks, and reporting."
                      >
                        <Info />
                      </Mui.Tooltip>
                    </Mui.Typography>
                  </Mui.Grid>
                  <Mui.Grid xs={8}>
                    <Mui.Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      size="small"
                      value={projectLead}
                      options={members}
                      filterOptions={(options, state) => {
                        return options.filter((option) =>
                          option.username
                            .toLowerCase()
                            .includes(state.inputValue.toLowerCase())
                        );
                      }}
                      renderOption={(props, option) => {
                        return <li {...props}>{option.username}</li>;
                      }}
                      ListboxProps={{
                        style: {
                          maxHeight: "150px",
                        },
                      }}
                      onChange={(event, value) => {
                        if (value) {
                          setProjectLead(value.username);
                          setProjectLeadId(value.user_id);
                          setValue("projectLead", value.username);
                          trigger("projectLead");
                        } else {
                          setProjectLead("");
                          setProjectLeadId(null);
                          setValue("projectLead", null);
                        }
                      }}
                      sx={{ width: "100%" }}
                      renderInput={(params) => (
                        <Mui.TextField
                          InputLabelProps={{
                            shrink: true,
                            sx: { fontSize: 17 },
                          }}
                          {...params}
                          {...register("projectLead", {
                            required: "Project lead is required",
                          })}
                          value={projectLead}
                          sx={{ background: themes.whiteColor }}
                          placeholder={projectPlaceholder.projectLead}
                          size="small"
                          error={errors.projectLead ? true : false}
                          InputProps={{
                            ...params.InputProps,
                            startAdornment: (
                              <>
                                <Person
                                  style={{
                                    margin: "0 8px",
                                    color: themes.allIconColor,
                                  }}
                                />{" "}
                                {params.InputProps.startAdornment}
                              </>
                            ),
                          }}
                        />
                      )}
                    />
                    {errors.projectLead && (
                      <Mui.Typography
                        sx={{
                          color: themes.redColor,
                          fontSize: 12,
                        }}
                      >
                        {errors.projectLead.message}
                      </Mui.Typography>
                    )}
                  </Mui.Grid>
                </Mui.Grid>

                <Mui.Grid container sx={{ padding: 1 }}>
                  <Mui.Grid xs={4}>
                    <Mui.Typography sx={formKeyText}>
                      Company&nbsp;
                      <Mui.Tooltip
                        arrow
                        slotProps={tooltipStyleProps}
                        title="Choose the company under which this project is being executed.This links the project to its organizational context.
"
                      >
                        <Info />
                      </Mui.Tooltip>
                    </Mui.Typography>
                  </Mui.Grid>
                  <Mui.Grid xs={8}>
                    <Mui.Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      size="small"
                      value={companyName}
                      options={allCompanies}
                      filterOptions={(options, state) => {
                        return options.filter((option) =>
                          option.companyname
                            .toLowerCase()
                            .includes(state.inputValue.toLowerCase())
                        );
                      }}
                      renderOption={(props, option) => {
                        return <li {...props}>{option.companyname}</li>;
                      }}
                      ListboxProps={{
                        style: {
                          maxHeight: "150px",
                        },
                      }}
                      onChange={(event, value) => {
                        if (value) {
                          setCompanyId(value.id);
                          setCompanyName(value.companyname);
                          setValue("company", value.companyname);
                          trigger("company");
                        } else {
                          setCompanyId(null);
                          setCompanyName("");
                          setValue("company", "");
                        }
                      }}
                      sx={{ width: "100%" }}
                      renderInput={(params) => (
                        <Mui.TextField
                          InputLabelProps={{
                            shrink: true,
                            sx: { fontSize: 17 },
                          }}
                          {...params}
                          {...register("company", {
                            required: "Company is required",
                          })}
                          value={companyName}
                          sx={{ background: themes.whiteColor }}
                          placeholder={projectPlaceholder.selectCompany}
                          size="small"
                          error={errors.company ? true : false}
                          InputProps={{
                            ...params.InputProps,
                            startAdornment: (
                              <>
                                <CorporateFare
                                  style={{
                                    margin: "0 8px",
                                    color: themes.allIconColor,
                                  }}
                                />{" "}
                                {params.InputProps.startAdornment}
                              </>
                            ),
                          }}
                        />
                      )}
                    />
                    {errors.company ? (
                      <Mui.Typography
                        sx={{ color: themes.redColor, fontSize: 12 }}
                      >
                        {errors.company?.message}
                      </Mui.Typography>
                    ) : null}
                  </Mui.Grid>
                </Mui.Grid>

                <Mui.Grid container sx={{ padding: 1 }}>
                  <Mui.Grid xs={12} sm={12} md={12} lg={4}>
                    <Mui.Typography sx={formKeyText}>
                      Client Id&nbsp;
                      <Mui.Tooltip
                        arrow
                        slotProps={tooltipStyleProps}
                        title="Enter the numeric ID associated with the client.It ensures backend referencing of client details."
                      >
                        <Info />
                      </Mui.Tooltip>
                    </Mui.Typography>
                  </Mui.Grid>
                  <Mui.Grid xs={8}>
                    <Mui.Autocomplete
                      disablePortal
                      fullWidth
                      id="combo-box-demo"
                      value={clientId}
                      options={allClientsId}
                      renderOption={(props, option) => {
                        if (option.clientname === "Create Client") {
                          return (
                            <li style={{ width: "100%" }} {...props}>
                              <Mui.Button
                                fullWidth={true}
                                sx={{
                                  textAlign: "center",
                                  width: "100%",
                                  textTransform: "capitalize",
                                }}
                                onClick={() => setOpenCreateClient(true)}
                              >
                                Add Client
                              </Mui.Button>
                            </li>
                          );
                        } else {
                          return <li {...props}>{option.label}</li>;
                        }
                      }}
                      ListboxProps={{
                        style: {
                          maxHeight: "120px",
                        },
                      }}
                      onChange={(event, value) => {
                        if (value) {
                          setClientUniqueId(value.id);
                          setClientId(value.clientid);
                          setValue("clientid", value.clientid);
                          setClientName(value.clientname);
                          setValue("clientname", value.clientname);
                        } else {
                          setClientUniqueId(null);
                          setClientName("");
                          setValue("clientname", "");
                          setClientId(0);
                          setValue("clientid", 0);
                        }
                      }}
                      sx={{ background: themes.whiteColor }}
                      renderInput={(params) => (
                        <Mui.TextField
                          InputLabelProps={{
                            shrink: true,
                            sx: { fontSize: 17 },
                          }}
                          {...params}
                          {...register("clientid", {
                            required: false,
                          })}
                          value={clientId}
                          sx={{ background: themes.whiteColor }}
                          placeholder={projectPlaceholder.selectClientId}
                          error={errors.clientid ? true : false}
                          helperText={errors.clientid?.message}
                          onKeyPress={handleKeyPress}
                          size="small"
                        />
                      )}
                    />
                  </Mui.Grid>
                </Mui.Grid>
                <Mui.Grid container sx={{ padding: 1 }}>
                  <Mui.Grid xs={4}>
                    <Mui.Typography sx={formKeyText}>
                      Client Name&nbsp;
                      <Mui.Tooltip
                        arrow
                        slotProps={tooltipStyleProps}
                        title="Select the client associated with the project.This will be used for billing, reporting, and communication purposes.
"
                      >
                        <Info />
                      </Mui.Tooltip>
                    </Mui.Typography>
                  </Mui.Grid>
                  <Mui.Grid xs={8}>
                    <Mui.Autocomplete
                      disablePortal
                      fullWidth
                      id="combo-box-demo"
                      value={clientName}
                      options={allClients}
                      filterOptions={(options, state) => {
                        return options.filter((option) =>
                          option.clientname
                            ?.toLowerCase()
                            .includes(state.inputValue.toLowerCase())
                        );
                      }}
                      renderOption={(props, option) => {
                        if (option.clientname === "Create Client") {
                          return (
                            <div style={{ justifyContent: "center" }}>
                              <Mui.Button
                                variant="text"
                                onClick={() => setOpenCreateClient(true)}
                                size="small"
                                sx={{
                                  textTransform: "capitalize",
                                  paddingLeft: 2,
                                }}
                              >
                                Add Client
                              </Mui.Button>
                            </div>
                          );
                        } else {
                          return <li {...props}>{option.clientname}</li>;
                        }
                      }}
                      ListboxProps={{
                        style: {
                          maxHeight: "120px",
                        },
                      }}
                      onChange={(event, value) => {
                        if (value) {
                          setClientUniqueId(value.id);
                          setClientName(value.clientname);
                          setValue("clientname", null);
                          setClientId(value.clientid);
                          setValue("clientid", value.clientid);
                        } else {
                          setClientUniqueId(null);
                          setClientName("");
                          setValue("clientname", "");
                          setClientId(0);
                          setValue("clientid", 0);
                        }
                      }}
                      sx={{ background: themes.whiteColor }}
                      renderInput={(params) => (
                        <Mui.TextField
                          InputLabelProps={{
                            shrink: true,
                            sx: { fontSize: 17 },
                          }}
                          {...params}
                          {...register("clientname", {
                            required: false,
                          })}
                          value={clientName}
                          sx={{ background: themes.whiteColor }}
                          placeholder={projectPlaceholder.selectClientName}
                          error={errors.clientname ? true : false}
                          helperText={errors.clientname?.message}
                          size="small"
                        />
                      )}
                    />
                  </Mui.Grid>
                </Mui.Grid>

                <Mui.Grid container sx={{ padding: 1 }}>
                  <Mui.Grid xs={4}>
                    <Mui.Typography sx={formKeyText}>
                      Estimated Amount&nbsp;
                      <Mui.Tooltip
                        arrow
                        slotProps={tooltipStyleProps}
                        title="Provide the estimated budget or value of the project.Helps in cost tracking and future revenue projections."
                      >
                        <Info />
                      </Mui.Tooltip>
                    </Mui.Typography>
                  </Mui.Grid>
                  <Mui.Grid xs={8}>
                    <Mui.TextField
                      InputLabelProps={{
                        shrink: true,
                        sx: { fontSize: 17 },
                      }}
                      fullWidth
                      sx={{ background: themes.whiteColor }}
                      {...register("estimateAmount", {
                        required: "Atleast one digits required",
                      })}
                      value={estimateAmount}
                      InputProps={{
                        inputProps: { maxLength: 10 },
                      }}
                      error={errors.estimateAmount ? true : false}
                      helperText={errors.estimateAmount?.message}
                      onKeyPress={handleKeyPress}
                      size="small"
                      onChange={(e) => setEstimateAmount(e.target.value)}
                    />
                  </Mui.Grid>
                </Mui.Grid>
                <Mui.Grid container sx={{ padding: 1 }}>
                  <Mui.Grid xs={4}>
                    <Mui.Typography sx={formKeyText}>
                      Visibility&nbsp;
                      <Mui.Tooltip
                        arrow
                        slotProps={tooltipStyleProps}
                        title="Toggle this option to control access:
                              On: All users will have access to this project.
                              Off: Restricted access, visible only to assigned users."
                      >
                        <Info />
                      </Mui.Tooltip>
                    </Mui.Typography>
                  </Mui.Grid>
                  <Mui.Grid xs={8}>
                    <Mui.FormControlLabel
                      control={
                        <Mui.Switch
                          onChange={() =>
                            setAutocompleteVisible(!autocompleteVisible)
                          }
                          sx={{
                            width: 70,
                            height: 50,

                            "& .MuiSwitch-thumb": {
                              width: 32,
                              height: 32,
                              color: autocompleteVisible
                                ? themes.primaryIndicator
                                : "none",
                            },
                            "& .MuiSwitch-switchBase + .MuiSwitch-track": {
                              borderRadius: 100 / 2,
                              backgroundColor: autocompleteVisible
                                ? themes.primaryIndicator
                                : "none",
                            },
                          }}
                          checked={autocompleteVisible}
                        />
                      }
                      label={
                        autocompleteVisible ? (
                          <Mui.Typography
                            sx={{
                              fontSize: 18,
                              fontWeight: "bold",
                            }}
                          >
                            Visible To Members
                          </Mui.Typography>
                        ) : (
                          <Mui.Typography
                            sx={{
                              fontSize: 18,
                              fontWeight: "bold",
                            }}
                          >
                            Access to All
                          </Mui.Typography>
                        )
                      }
                    />
                    {autocompleteVisible && (
                      <>
                        <Mui.Grid
                          container
                          direction="row"
                          sx={{ paddingBottom: 0.5 }}
                        >
                          <Mui.Typography
                            sx={{
                              fontSize: 15,
                            }}
                          >
                            Add Members (Optional)
                          </Mui.Typography>
                        </Mui.Grid>

                        <div {...getRootProps()}>
                          <InputWrapper
                            sx={{
                              width: "100%",
                              minHeight: 50,
                              mt: 1,
                              mb: 1,
                              padding: 1.5,
                              background: themes.whiteColor,
                            }}
                            ref={setAnchorEl}
                          >
                            {selectedMembers.map((option, index) => (
                              <StyledTag
                                label={option.username}
                                {...getTagProps({ index })}
                              />
                            ))}
                            <input
                              {...getInputProps()}
                              style={{ background: themes.whiteColor }}
                            />
                          </InputWrapper>
                        </div>
                        {groupedOptions.length > 0 ? (
                          <Listbox
                            {...getListboxProps()}
                            autocompleteVisible={autocompleteVisible}
                            sx={{ background: themes.whiteColor }}
                          >
                            {groupedOptions.map((option, index) => (
                              <li
                                {...getOptionProps({ option, index })}
                                key={option.id || index}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 10,
                                  padding: 8,
                                }}
                              >
                                <Mui.Avatar
                                  src={option.image_url || optionalAvathar}
                                  alt={option.username}
                                  sx={{ width: 28, height: 28 }}
                                />
                                <span>{option.username}</span>
                                <Check fontSize="small" />
                              </li>
                            ))}
                          </Listbox>
                        ) : null}
                      </>
                    )}
                  </Mui.Grid>
                </Mui.Grid>

                <Mui.Grid container spacing={2}>
                  <Mui.Grid xs={11}></Mui.Grid>
                  <Mui.Grid item xs={1}>
                    <CustomButton typeName="submit" actionName="Next" />
                  </Mui.Grid>
                </Mui.Grid>
              </Mui.Grid>
            </Mui.Grid>
          </form>

          <CreateClient
            handleCloseDialogBox={handleCloseDialogBox}
            openCreateClient={openCreateClient}
          />
        </>
      ) : (
        getComponent(page)
      )}
    </React.Fragment>
  );
};

export default NewProjects;

const InputWrapper = Mui.styled("div")(
  ({ theme, autocompleteVisible }) => `
  width: 100%; 
   border: 1px solid ${theme.palette.mode === "dark" ? "#434343" : "#d9d9d9"};
   background-color: ${theme.palette.mode === "dark" ? "#141414" : "#fff"};
   border-radius: 4px;
   padding: 1px;
   display: flex;
   flex-wrap: wrap;
   
   &:hover {
     border-color: ${theme.palette.mode === "dark" ? "#177ddc" : "#40a9ff"};
   }

   ${
     autocompleteVisible
       ? `
       &.focused {
         border-color: ${theme.palette.mode === "dark" ? "#177ddc" : "#40a9ff"};
         box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
       }
     `
       : ""
   }

   & input {
     background-color: ${theme.palette.mode === "dark" ? "#141414" : "#fff"};
     color: ${
       theme.palette.mode === "dark"
         ? "rgba(255,255,255,0.65)"
         : "rgba(0,0,0,.85)"
     };
    
    
     flex-grow: 1;
     border: 0;
     margin: 0;
     outline: 0;
   }
`
);

const Listbox = Mui.styled("ul")(
  ({ theme, autocompleteVisible }) => `
   width: 350px;
   margin: 2px 0 0;
   padding: 0;
   position: absolute;
   list-style: none;
   background-color: ${theme.palette.mode === "dark" ? "#141414" : "#fff"};
   overflow: auto;
   max-height: 150px;
   border-radius: 4px;
   box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
   z-index: 1;
  
   ${
     autocompleteVisible
       ? `
     background-color: ${theme.palette.mode === "dark" ? "#141414" : "#fff"};
   `
       : ""
   }
  
   & li {
     padding: 5px 12px;
     display: flex;
  
     & span {
       flex-grow: 1;
     }
  
     & svg {
       color: transparent;
     }
   }
  
   & li[aria-selected='true'] {
     background-color: ${theme.palette.mode === "dark" ? "#2b2b2b" : "#fafafa"};
     font-weight: 600;
  
     & svg {
       color: #1890ff;
     }
   }
  
   & li.${Mui.autocompleteClasses.focused} {
     background-color: ${theme.palette.mode === "dark" ? "#003b57" : "#e6f7ff"};
     cursor: pointer;
  
     & svg {
       color: currentColor;
     }
   }
`
);

function Tag(props) {
  const { label, onDelete, ...other } = props;
  return (
    <div {...other}>
      <span>{label}</span>
      <Close onClick={onDelete} />
    </div>
  );
}

Tag.propTypes = {
  label: PropTypes.string.isRequired,
  onDelete: PropTypes.func.isRequired,
};

const StyledTag = Mui.styled(Tag)(
  ({ theme }) => `
  display: flex;
  align-items: center;
  height: 34px;
  margin: 2px;
  line-height: 22px;
  border-radius: 25px;
  background-color: ${
    theme.palette.mode === "dark" ? "rgba(255,255,255,0.08)" : "#fafafa"
  };
  border: 1px solid ${theme.palette.mode === "dark" ? "#303030" : "#e8e8e8"};
  border-radius: 2px;
  box-sizing: content-box;
  padding: 0 4px 0 10px;
  outline: 0;
  overflow: hidden;
  border-radius: 25px;

  &:focus {
    border-color: ${theme.palette.mode === "dark" ? "#177ddc" : "#40a9ff"};
    background-color: ${theme.palette.mode === "dark" ? "#003b57" : "#e6f7ff"};
  }

  & span {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  & svg {
    font-size: 12px;
    cursor: pointer;
    padding: 4px;
  }
`
);
